module.exports = __webpack_public_path__ + "img/1-3.908d76bf.jpg";